import { Button, Container } from '@cluey/cluey-components';
import { useHistory } from 'react-router-dom';

import AnnoyedFace from '../../../assets/images/icon-annoyed.svg';
import { PATH_HUB_HOME } from '../../legacy/pagePath';

const PauseNotAllowed = () => {
  const history = useHistory();
  return (
    <Container>
      <div className="page-error m-auto flex flex-col items-center py-10 text-center">
        <div className="rounded bg-white p-10">
          <div className="relative mb-6 flex w-full justify-center">
            <img src={AnnoyedFace} alt="Error" className="rounded-full bg-blood-orange-1" />
          </div>
          <h3 className="mb-4 text-lg font-bold">Pausing unavailable</h3>
          <p className="mb-8 font-bold">This enrolment cannot be paused right now.</p>

          <Button
            size="lg"
            onClick={() => {
              history.push(PATH_HUB_HOME);
            }}
          >
            Return to home
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default PauseNotAllowed;
